var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStrokeLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "password 1",
    clipPath: "url(#clip0_2_17333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_17333",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath1805"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1803",
    d: "M0.5 0.833254H20.5V20.8333H0.5V0.833254Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_17333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1807"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1809",
    d: "M6.82812 20.052H14.1719C16.3292 20.052 18.0781 18.3031 18.0781 16.1458V12.1614C18.0781 10.004 16.3292 8.25513 14.1719 8.25513H6.82812C4.67078 8.25513 2.92188 10.004 2.92188 12.1614V16.1458C2.92188 18.3031 4.67078 20.052 6.82812 20.052Z",
    stroke: "#B8E6FB",
    strokeWidth: 1.59147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1813",
    d: "M13.7413 4.85663C13.7413 3.078 12.2995 1.61448 10.5208 1.61448C8.74217 1.61448 7.30029 3.05636 7.30029 4.83499V8.21655",
    stroke: "#B8E6FB",
    strokeWidth: 1.59147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1815"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1817",
    d: "M10.5 15.1692V16.7317",
    stroke: "#B8E6FB",
    strokeWidth: 1.59147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1821",
    d: "M8.9375 13.3723C8.9375 14.2352 9.63707 14.9348 10.5 14.9348C11.3629 14.9348 12.0625 14.2352 12.0625 13.3723C12.0625 12.5094 11.3629 11.8098 10.5 11.8098C9.63707 11.8098 8.9375 12.5094 8.9375 13.3723Z",
    stroke: "#B8E6FB",
    strokeWidth: 1.59147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_17333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.833252)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStrokeLock);
export default __webpack_public_path__ + "static/media/icon-stroke-lock.c3ad2dcb38f8a056533d4e99543fafe4.svg";
export { ForwardRef as ReactComponent };